import React from "react";
import DatePickerComponentV2 from "../../DatePickerComponentV2";
import DropDownAllStaffsV2 from "../../Dropdowns/DropDownAllStaffsV2";
import DropDownSpecificStaffV2 from "../../Dropdowns/DropDownSpecificStaffV2";
import DropDownRoomsNumber from "../../Dropdowns/DropdownRoomsNumber";
import DropDownComponentSortedV2 from "../../DropDownComponentSortedV2";

function GeneralInformationTreatmentSection(props) {
  const {
    translate,
    clientStatus,
    handleClientStatusChange,
    roomNumber,
    handleRoomNumberChange,
    clientIdState,
    sourceClientStatus,
    firstName,
    lastName,
    profilePicture,
    selectedTherapist,
    handleSelectedTherapistChange,
    assignedSupportWorker,
    handleAssignedSupportWorkerChange,
  } = props;

  return (
    <div style={{ padding: "0px", width: "100%", paddingBottom: "20px" }}>
      <div style={{ borderTop: "1px solid #cccccc", paddingTop: "20px", marginTop: "20px" }}>
        <span id="treatment-information" style={{ fontSize: "18px", fontWeight: "600" }}>{translate("TreatmentInformation")}</span>
      </div>
      <div style={{ gap: "10px", display: "flex", flexDirection: "row", alignItems: "flex-end" }}>
        <DropDownComponentSortedV2 api="clientStatus" title={translate("ClientStatus")} value={clientStatus} onChange={handleClientStatusChange} width="250px" />
        <DropDownRoomsNumber
          title="Room number"
          width="100px"
          value={roomNumber}
          onChange={handleRoomNumberChange}
          clientId={clientIdState}
          clientStatus={sourceClientStatus}
          clientFirstName={firstName}
          clientLastName={lastName}
          profilePictureUrl={profilePicture}
        />
        <DropDownAllStaffsV2 title={translate("AssignedTherapist")} value={selectedTherapist} width="auto" onChange={handleSelectedTherapistChange} />
        <DropDownSpecificStaffV2 title={translate("AssignedSupportStaff")} value={assignedSupportWorker} onChange={handleAssignedSupportWorkerChange} allowedRoles={["Support Staff"]} width="250px" />
      </div>
    </div>
  );
}

export default GeneralInformationTreatmentSection;
